import { EntityAudit } from "@modernary/mui/components/audit";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  people: "Person.People",
  list: "Person.PersonList",
  new: "Person.PersonNew",
  base: "Person.PersonBase",
  view: "Person.PersonView",
  edit: "Person.PersonEdit",
  audit: "Person.PersonAudit",
  electronicForms: "Person.ElectronicForms",
  permitVersions: "Person.PermitVersions",
};

export { names as personRouteNames };

const personRoutes: RouterOptions["routes"] = [
  {
    path: "/person",
    name: names.people,
    component: { render: () => <RouterView /> },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "People" },
        component: () => import("./PersonList.vue"),
      },
      {
        path: "new",
        component: () => import("./PersonBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Person", isNew: true, isForm: true },
            component: () => import("./PersonEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("./PersonBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Person View" },
            component: () => import("./PersonView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Person Edit", isForm: true },
            component: () => import("./PersonEdit.vue"),
          },
          {
            path: "electronic-forms",
            name: names.electronicForms,
            meta: { title: "Person Electronic Forms" },
            component: () => import("./PersonElectronicFormList.vue"),
          },
          {
            path: "permits",
            name: names.permitVersions,
            meta: { title: "Person Permits" },
            component: () => import("./PersonPermitList.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Person Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Person" />,
            },
          },
        ],
      },
    ],
  },
];

export default personRoutes;
